export enum UserAccess {
  Annual = 'annual',
  Pro = 'pro',
}

export const DEFAULT_READING_STAT_VALUES = [0, '0', '', ' mins'];
export const EMPTY_RESULTS = 'empty results';
export const VIEW_ALL = 'View all';
export const VIEW_ALL_ORG_CHARTS = 'View all Org Charts';

export enum ProjectTheme {
  Database = 'database',
  TalentTracker = 'talent_tracker',
}

export const THEME_LABELS: Record<string, string> = {
  [ProjectTheme.Database]: 'Database',
  [ProjectTheme.TalentTracker]: 'Tracker',
};

export const FOR_YOU_COMPONENT_LIST = {
  [UserAccess.Annual]: [
    'ReadingStats',
    'Nav',
    'RecommendedArticles',
    'Topics',
    'Reporters',
    'Newsletters',
    'CommunityInsights',
  ],
  [UserAccess.Pro]: [
    'ReadingStats',
    'Nav',
    'RecommendedArticles',
    'DataTools',
    'Topics',
    'Reporters',
    'Newsletters',
    'DeepResearch',
    'OrgCharts',
    'CommunityInsights',
  ],
};

export const FOR_YOU_SECTION_IDS = {
  CommunityInsights: 'community',
  DeepResearch: 'deep-research',
  DataTools: 'data-tools',
  Newsletters: 'newsletters',
  OrgCharts: 'org-charts',
  ReadingStats: 'reading-stats',
  RecommendedArticles: 'recommended-articles',
  Reporters: 'reporters',
  Topics: 'topics',
} as const;

export const FOR_YOU_NAV_ITEMS = [
  { id: FOR_YOU_SECTION_IDS.RecommendedArticles, label: 'Recommended Articles' },
  { id: FOR_YOU_SECTION_IDS.DataTools, label: 'Data Tools' },
  { id: FOR_YOU_SECTION_IDS.Topics, label: 'Trending' },
  { id: FOR_YOU_SECTION_IDS.Reporters, label: 'Reporters' },
  { id: FOR_YOU_SECTION_IDS.Newsletters, label: 'Newsletters' },
  { id: FOR_YOU_SECTION_IDS.DeepResearch, label: 'Deep Research' },
  { id: FOR_YOU_SECTION_IDS.OrgCharts, label: 'Org Charts' },
  { id: FOR_YOU_SECTION_IDS.CommunityInsights, label: 'Community' },
] as const;

export const FOR_YOU_ENGAGEMENT_LABELS = {
  Engaged: {
    NonPro: {
      RecommendedArticles: {
        label: 'For You',
        title: 'Recommended Articles',
        subtitle: 'Curated based on your recent reading and topic preferences.',
      },
    },
    Pro: {
      RecommendedArticles: {
        label: 'For You',
        title: 'Recommended Articles',
        subtitle: 'Curated based on your recent reading and topic preferences.',
      },
      DeepResearch: {
        label: 'Included in Pro',
        title: 'Deep Research',
      },
      OrgCharts: {
        label: 'Catch up',
        title: 'Org Charts',
        subtitle: 'Continue exploring leadership teams across top companies.',
      },
      DataTools: {
        label: 'Related to Recent Coverage',
        title: 'Data Tools',
        subtitle: 'Continue exploring our proprietary databases and projects.',
      },
    },
    Topics: {
      label: 'Following',
      title: 'Topics',
      subtitle: 'Stay current on the topics you follow.',
    },
    Reporters: {
      label: 'Following',
      title: 'Reporters',
      subtitle: 'Stay up to date with the journalists you follow.',
    },
    CommunityInsights: {
      label: 'Trending',
      title: 'Community & Insights',
      subtitle: 'Catch up on your posts, comments and followed threads.',
    },
  },
  NotEngaged: {
    NonPro: {
      RecommendedArticles: {
        label: 'Trending',
        title: 'Most Popular Articles',
        subtitle: 'Discover what readers are reading.',
      },
    },
    Pro: {
      RecommendedArticles: {
        label: 'Trending',
        title: 'Most Popular Articles',
        subtitle: 'Discover what readers are reading.',
      },
      DeepResearch: {
        label: 'Included in Pro',
        title: 'Deep Research',
      },
      OrgCharts: {
        label: 'Included in Pro',
        title: 'Org Charts',
        subtitle: 'Explore leadership teams across top companies.',
      },
      DataTools: {
        label: 'Included in Pro',
        title: 'Data Tools',
        subtitle: 'Structured proprietary databases and projects beyond headlines.',
      },
    },
    Topics: {
      label: 'Recommended',
      title: 'Topics',
      subtitle: 'Follow topics to personalize your coverage.',
    },
    Reporters: {
      label: 'Recommended',
      title: 'Reporters',
      subtitle: 'Discover journalists covering your interests.',
    },
    CommunityInsights: {
      label: 'Trending',
      title: 'Community & Insights',
      subtitle: 'Join discussions on the stories shaping tech and business.',
    },
  },
  Subscribed: {
    Newsletters: {
      label: 'Subscribed',
      title: 'Newsletters',
      subtitle: 'Catch up on your latest newsletter editions.',
    },
    ReadingStats: {
      label: 'For You',
      title: 'Your Reading Summary',
      subtitle: 'Track your reading habits over the past month.',
    },
  },
  NotSubscribed: {
    Newsletters: {
      label: 'Recommended',
      title: 'Newsletters',
      subtitle: 'A snapshot of what you’ve been reading the last 30 days.',
    },
  },
};
